import { FC } from 'react'
import { styled, Theme } from '@mui/material/styles'
import { Sidebar as RaSidebar, SidebarProps, useSidebarState } from 'react-admin'
import { themeColor } from './themes'

const Sidebar: FC<SidebarProps> = (props) => {
  const [open] = useSidebarState()
  const styleProps = { open }

  return (
    <StyledSidebar
      classes={classes}
      className={classes.root}
      size={200}
      {...props}
      {...styleProps}
    />
  )
}

interface StyleProps {
  open?: boolean;
}

const PREFIX = 'xxllncSidebar'

const classes = {
  root: `${PREFIX}-root`,
  drawerPaper: `${PREFIX}-drawerPaper`,
  fixed: `${PREFIX}-fixed`,
}

const StyledSidebar = styled(RaSidebar, {
  name: PREFIX,
  overridesResolver: (props, styles) => styles.root,
})(({ theme, open }: StyleProps & { theme: Theme }) => ({
  [`&.${classes.root}`]: {},
  [`& .${classes.drawerPaper}`]: {
    border: 'none',
  },
  ['& .RaSidebar-fixed']: {
    boxSizing: 'border-box',
    overflowX: 'hidden',
    position: 'fixed',
    width: 'inherit',
    height: '100vh',
    paddingLeft: open ? theme.spacing(1.5) : 10,
    paddingRight: open ? theme.spacing(1.5) : 10,
    borderRight: '1px solid ' + themeColor.sidebarBorder,
    backgroundColor: themeColor.sidebarBg,
    ['& .MuiBox-root']: {
      marginTop: 0,
    },
  },
}))

export default Sidebar
